(function () {
  'use strict';
  // Shared registration prevents duplicate loops when several sections load this asset.
  if (window.MVTagWheel) { window.MVTagWheel.init(document); return; }
  var instances = new Map();
  function init(root) {
    var sections = Array.from(root.querySelectorAll('[data-mv-wheel-section]'));
    if (root.matches && root.matches('[data-mv-wheel-section]')) sections.unshift(root);
    sections.forEach(function (section) {
      if (instances.has(section)) return;
      var controller = new AbortController();
      var cleanup = function () {};
      instances.set(section, function () { controller.abort(); cleanup(); });
      load(section, controller.signal).then(function (products) {
        if (controller.signal.aborted || !section.isConnected) return;
        var wrap = section.querySelector('[data-mv-wheel]');
        var status = section.querySelector('[data-mv-wheel-status]');
        wrap.setAttribute('aria-busy', 'false');
        if (!products.length) {
          status.textContent = section.dataset.designMode ? 'No matching products. Check the exact tag, product image, Active status, Online Store publication and search visibility.' : 'No products available yet.';
          return;
        }
        build(section, products);
        status.hidden = true;
        cleanup = animate(section);
      }).catch(function (error) {
        if (controller.signal.aborted) return;
        section.querySelector('[data-mv-wheel]').setAttribute('aria-busy', 'false');
        section.querySelector('[data-mv-wheel-status]').textContent = section.dataset.designMode ? 'Product loading failed. Confirm templates/search.mv-wheel-data.liquid is saved in this same theme, then reload.' : 'Products could not load. Please refresh the page.';
        console.error('[MV Product Wheel]', error);
      });
    });
  }
  async function load(section, signal) {
    var tag = (section.dataset.productTag || '0926').trim();
    var query = 'tag:"' + tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
    var url = new URL(section.dataset.searchUrl, window.location.origin);
    url.searchParams.set('view', 'mv-wheel-data');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    url.searchParams.set('options[unavailable_products]', 'show');
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    var products = [], seen = new Set(), pages = 1;
    // Fetch matching search pages, not the first 50 products in collections.all.
    for (var page = 1; page <= pages; page++) {
      url.searchParams.set('page', String(page));
      var response = await fetch(url.toString(), { signal: signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Search HTTP ' + response.status);
      var data = JSON.parse(await response.text());
      if (data.mv_wheel_version !== 1 || !Array.isArray(data.products) || data.page !== page || !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 500) throw new Error('Unexpected wheel search template response');
      pages = data.pages;
      data.products.forEach(function (product) {
        // Exact array membership excludes tags such as "0926-extra".
        if (!Array.isArray(product.tags) || !product.tags.includes(tag) || !product.image || !product.url || seen.has(product.id)) return;
        seen.add(product.id);
        products.push(product);
      });
    }
    return products;
  }
  function build(section, products) {
    var wrap = section.querySelector('[data-mv-wheel]');
    var ring = wrap.querySelector('[data-mv-wheel-ring]');
    ring.replaceChildren();
    products.forEach(function (product, index) {
      var item = document.createElement('div');
      item.className = 'mv-wheel-item';
      item.style.setProperty('--base-angle', 360 / products.length * index);
      item.setAttribute('data-mv-wheel-item', '');
      item.dataset.index = index;
      item.dataset.title = product.title;
      item.dataset.url = product.url;
      item.dataset.image = product.image;
      var button = document.createElement('button');
      button.type = 'button'; button.className = 'mv-wheel-item__btn';
      button.setAttribute('aria-label', 'Select ' + product.title);
      var inner = document.createElement('span'); inner.className = 'mv-wheel-item__inner';
      var img = document.createElement('img'); img.className = 'mv-wheel-item__img';
      img.src = product.thumbnail || product.image; img.alt = product.title;
      img.width = 600; img.height = 600; img.loading = 'lazy'; img.decoding = 'async'; img.draggable = false;
      inner.appendChild(img); button.appendChild(inner); item.appendChild(button); ring.appendChild(item);
    });
    wrap.dataset.total = products.length;
    section.querySelector('[data-mv-wheel-center]').hidden = false;
  }
  function animate(section) {
    var wrap = section.querySelector('[data-mv-wheel]');
    var items = Array.from(wrap.querySelectorAll('[data-mv-wheel-item]'));
    var centerImg = section.querySelector('[data-mv-wheel-center-img]');
    var centerLink = section.querySelector('[data-mv-wheel-center-link]');
    var centerCta = section.querySelector('[data-mv-wheel-center-cta]');
    var total = items.length;
    var duration = (Number(wrap.dataset.speed) || 80) * 1000;
    var pauseMs = Number(wrap.dataset.pauseMs) || 4000;
    var rotation = 0, current = -1, last = null, raf = 0, pauseUntil = 0;
    var hovering = false, focused = false, destroyed = false, fadeTimer = 0;
    var token = 0, pendingImage = null, drag = null, suppressClickUntil = 0;
    var listeners = new AbortController();
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function on(target, name, fn, capture) { target.addEventListener(name, fn, { signal: listeners.signal, capture: !!capture }); }
    function setRotation(deg) { rotation = (deg % 360 + 360) % 360; wrap.style.setProperty('--ring-rot', rotation); }
    function nearest() { return Math.round((360 - rotation) / (360 / total)) % total; }
    function update(index) {
      if (index === current) return;
      current = index;
      var item = items[index], ticket = ++token;
      clearTimeout(fadeTimer);
      if (pendingImage) { pendingImage.onload = null; pendingImage.onerror = null; }
      function commit() {
        if (destroyed || ticket !== token) return;
        // Change the image and BOTH links together so clicks never target a different product.
        centerImg.src = item.dataset.image; centerImg.alt = item.dataset.title;
        centerLink.href = item.dataset.url; centerCta.href = item.dataset.url;
        centerLink.setAttribute('aria-label', item.dataset.title);
        centerImg.classList.remove('is-fading');
      }
      if (!centerImg.getAttribute('src')) { commit(); return; }
      var image = new Image(); pendingImage = image;
      image.onload = function () {
        if (destroyed || ticket !== token) return;
        centerImg.classList.add('is-fading');
        fadeTimer = setTimeout(commit, reduced.matches ? 0 : 120);
      };
      image.onerror = function () { if (ticket === token) centerImg.classList.remove('is-fading'); };
      image.src = item.dataset.image;
    }
    function tick(now) {
      if (destroyed) return;
      if (!document.hidden && !reduced.matches && total > 1 && !hovering && !focused && !drag && now >= pauseUntil) {
        if (last !== null) { setRotation(rotation + Math.min(now - last, 100) * 360 / duration); update(nearest()); }
        last = now;
      } else last = null;
      raf = requestAnimationFrame(tick);
    }
    function angle(e) { var r = wrap.getBoundingClientRect(); return Math.atan2(e.clientY - r.top - r.height / 2, e.clientX - r.left - r.width / 2) * 180 / Math.PI; }
    on(wrap, 'pointerdown', function (e) {
      if (!e.isPrimary || e.button !== 0 || e.target.closest('.mv-wheel-center') || drag) return;
      drag = { id: e.pointerId, angle: angle(e), rotation: rotation, x: e.clientX, y: e.clientY, moved: false };
      suppressClickUntil = 0;
    });
    on(window, 'pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (Math.hypot(e.clientX - drag.x, e.clientY - drag.y) > 5) drag.moved = true;
      if (drag.moved) { setRotation(drag.rotation + angle(e) - drag.angle); update(nearest()); }
    });
    function end(e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (drag.moved) suppressClickUntil = performance.now() + 400;
      drag = null; pauseUntil = performance.now() + pauseMs;
    }
    on(window, 'pointerup', end); on(window, 'pointercancel', end);
    on(window, 'blur', function () { drag = null; hovering = false; pauseUntil = performance.now() + pauseMs; });
    on(wrap, 'click', function (e) {
      if (e.detail !== 0 && performance.now() < suppressClickUntil) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    items.forEach(function (item, index) {
      on(item.querySelector('button'), 'click', function () {
        if (index === current && centerLink.getAttribute('href') === item.dataset.url) { window.location.assign(item.dataset.url); return; }
        setRotation(-index * 360 / total); update(index); pauseUntil = performance.now() + pauseMs;
      });
    });
    on(wrap, 'pointerenter', function (e) { if (e.pointerType === 'mouse') hovering = true; });
    on(wrap, 'pointerleave', function (e) { if (e.pointerType === 'mouse') { hovering = false; pauseUntil = performance.now() + pauseMs; } });
    on(wrap, 'focusin', function (e) { focused = e.target.matches(':focus-visible'); });
    on(wrap, 'focusout', function (e) { if (!wrap.contains(e.relatedTarget)) { focused = false; pauseUntil = performance.now() + pauseMs; } });
    setRotation(0); update(0); raf = requestAnimationFrame(tick);
    return function () { destroyed = true; token++; listeners.abort(); cancelAnimationFrame(raf); clearTimeout(fadeTimer); if (pendingImage) { pendingImage.onload = null; pendingImage.onerror = null; } };
  }
  window.MVTagWheel = { init: init };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (destroy, section) { if (e.target === section || e.target.contains(section)) { destroy(); instances.delete(section); } });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
